import React from "react"
import { Card, CardBody, Button, Container, Row, Col } from "reactstrap"
import pulaAwardsContent from "../../assets/images/users/pula_awards_content.png"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

const AwardsInfo = () => {
  const navigate = useNavigate()
  const dashboardData = useSelector(state => state.auth.dashboardData) || {}
  const userAwards = useSelector(state => state.auth.awards)

  const activeAward =
    dashboardData.active_award && dashboardData.active_award.length > 0
      ? dashboardData.active_award[0]
      : null

  const activeApplication =
    userAwards && userAwards.length > 0 ? userAwards[0] : null

  const awardStatusColor = status => {
    const map = {
      pending:       { bg: "rgba(255,185,30,0.15)",  color: "#ffb91e", border: "rgba(255,185,30,0.35)"  },
      paid:          { bg: "rgba(34,197,94,0.15)",   color: "#22c55e", border: "rgba(34,197,94,0.35)"   },
      shortlisted:   { bg: "rgba(139,92,246,0.2)",   color: "#a78bfa", border: "rgba(139,92,246,0.4)"   },
      rejected:      { bg: "rgba(239,68,68,0.15)",   color: "#f87171", border: "rgba(239,68,68,0.35)"   },
      clarification: { bg: "rgba(249,115,22,0.15)",  color: "#fb923c", border: "rgba(249,115,22,0.35)"  },
    }
    return map[status] || map.pending
  }

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div className="container-fluid" style={{ padding: 0 }}>

        {/* ── Awards banner ── */}
        <div className="pula-awards-card pula-awards-info-banner">
          <div className="awards-card-content w-100">
            <Row className="align-items-center">
              <Col md={8}>
                <p className="awards-card-subtitle">
                  Celebrating PULA&apos;s SuperWomen
                </p>
                <h2 className="awards-card-title">
                  {activeAward ? activeAward.title : "PULA Awards"}
                  <span className="awards-trophy">🏆</span>
                </h2>

                {activeApplication ? (
                  /* Has active application */
                  <>
                    <div className="awards-app-meta">
                      <span className="awards-meta-label">Category</span>
                      <span className="awards-meta-value">
                        {activeApplication.category_label}
                      </span>
                    </div>
                    {activeAward && (
                      <div className="awards-app-meta">
                        <span className="awards-meta-label">Date</span>
                        <span className="awards-meta-value">
                          {activeAward.award_date}
                          {activeAward.time_slot && (
                            <span className="ms-2 opacity-75">
                              · {activeAward.time_slot}
                            </span>
                          )}
                        </span>
                      </div>
                    )}
                    <div className="awards-status-row">
                      <span
                        className="awards-status-badge"
                        style={{
                          background:   awardStatusColor(activeApplication.status).bg,
                          color:        awardStatusColor(activeApplication.status).color,
                          borderColor:  awardStatusColor(activeApplication.status).border,
                        }}
                      >
                        <span
                          className="awards-status-dot"
                          style={{ background: awardStatusColor(activeApplication.status).color }}
                        />
                        {activeApplication.status_label}
                      </span>
                    </div>
                  </>
                ) : activeAward ? (
                  /* Active season, no application */
                  <>
                    <p className="awards-card-description mb-1">
                      <i className="mdi mdi-calendar-outline me-1" />
                      {activeAward.award_date}
                      {activeAward.time_slot && (
                        <span className="ms-2 opacity-75">
                          · {activeAward.time_slot}
                        </span>
                      )}
                    </p>
                    <p className="awards-card-description">
                      Nominations are open. Celebrate and showcase your journey
                      with PULA.
                    </p>
                  </>
                ) : (
                  /* No active season */
                  <p className="awards-card-description">
                    Join us in honouring women and empowering businesses.
                  </p>
                )}
              </Col>

              {activeAward && (
                <Col md={4} className="text-md-end mt-3 mt-md-0">
                  <Button
                    color="primary"
                    className="btn-lg awards-info-cta-btn"
                    onClick={() => navigate("/awards/" + activeAward.url)}
                  >
                    {activeApplication ? "Update My Details" : "Nominate Now"}
                    <i className="mdi mdi-arrow-right ms-2" />
                  </Button>
                </Col>
              )}
            </Row>
          </div>
        </div>

        <div className="justify-content-center p-5 h-100">
          <h3 className="h3 mb-4 nom-title">About PULA Entrepreneur Awards</h3>

          <Row className="align-items-start ">
            <Col md={7}>
              <p
                style={{
                  color: "#7a6b8a",
                  fontSize: "1.05rem",
                  lineHeight: "1.8",
                }}
              >
                The PULA Entrepreneur Awards is a celebration of women who dare
                to build, lead, and inspire. Rooted in the PULA (Pune Ladies)
                community, these awards honor the resilience, innovation, and
                impact of women entrepreneurs across diverse industries. From
                early-stage founders to established business leaders, the awards
                spotlight journeys that reflect courage, consistency, and
                meaningful contribution to society. These remarkable women
                exemplify the spirit of entrepreneurship and serve as beacons of
                inspiration for future generations.
              </p>
            </Col>
            <Col md={5} className="d-flex align-items-center">
              <img
                src={pulaAwardsContent}
                alt="PULA Awards Event"
                className="img-fluid rounded shadow-sm"
                style={{ width: "100%", objectFit: "cover" }}
              />
            </Col>
          </Row>

          <p
            style={{
              color: "#7a6b8a",
              fontSize: "1.05rem",
              lineHeight: "1.8",
              marginBottom: "0",
            }}
          >
            At PULA, we believe every woman's story deserves recognition
            especially those who grow businesses while uplifting others along
            the way. The Entrepreneur Awards are designed to be transparent,
            inclusive, and purpose-driven, offering women a credible platform to
            showcase their work, gain visibility, and be acknowledged for their
            efforts. More than just trophies, the awards represent validation,
            encouragement, and a powerful reminder that women-led businesses
            matter.
          </p>
          <p
            style={{
              color: "#7a6b8a",
              fontSize: "1.05rem",
              lineHeight: "1.8",
              marginBottom: "2rem",
            }}
          >
            Beyond recognition, the PULA Entrepreneur Awards foster a strong
            ecosystem of connection and growth. Awardees and nominees become
            part of a supportive network that opens doors to mentorship,
            collaboration, media exposure, and community leadership. Through
            these awards, PULA continues its mission to amplify women’s voices,
            celebrate their achievements, and inspire the next generation of
            women entrepreneurs to step forward with confidence.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AwardsInfo
